import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-7YF3QTSS38';

// Inicializar Google Analytics
export const initGA = () => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics inicializado');
  }
};

// Componente para rastrear mudanças de página
export const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      // Rastrear visualização de página
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
      
      // Rastrear eventos personalizados
      ReactGA.event({
        category: 'Navigation',
        action: 'Page View',
        label: location.pathname
      });
    }
  }, [location]);

  return null;
};

// Funções úteis para rastrear eventos
export const trackEvent = (category, action, label = null, value = null) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

// Rastrear cliques em links
export const trackLinkClick = (linkName, linkUrl) => {
  trackEvent('Link Click', 'Click', linkName);
  console.log(`Link clicado: ${linkName} - ${linkUrl}`);
};

// Rastrear downloads
export const trackDownload = (fileName) => {
  trackEvent('Download', 'Download', fileName);
};

// Rastrear formulários
export const trackFormSubmit = (formName) => {
  trackEvent('Form', 'Submit', formName);
};

// Rastrear tempo na página
export const trackTimeOnPage = (pageName, timeSpent) => {
  trackEvent('Engagement', 'Time on Page', pageName, timeSpent);
};

export default GoogleAnalyticsTracker;
